import React from 'react';
import { Box, Paper, Typography, Divider, Grid, Avatar } from '@mui/material';

const AverageGradeCard = ({ data = [] }) => {
  const normalizeRatings = (data: any) => {
    if (Array.isArray(data)) return data;

    if (typeof data === 'object' && data !== null) {
      return Object.entries(data).map(([rating, count]) => ({
        rating,
        count,
      }));
    }

    return [];
  };

  const calculateMetrics = (listData: any) => {
    const mapping = { S: 0, 5: 5, 4: 4, 3: 3, 2: 2, 1: 1, 0: 0 };

    const dataArray = normalizeRatings(listData);

    const validRatings = dataArray.filter(
      (item) => item.rating !== '' && item.rating !== 'To be done' && item.rating !== 'S'
    );

    let totalWeightedScore = 0;
    let totalCount = 0;

    validRatings.forEach((item) => {
      const weight = mapping[item.rating] ?? 1;
      totalWeightedScore += weight * item.count;
      totalCount += item.count;
    });

    const averageRating = Math.round(totalCount > 0 ? totalWeightedScore / totalCount : 0);

    const averageGrade = '0';

    return {
      averageGrade,
      averageRating: Number(averageRating),
      objectiveRating: 4.3,
    };
  };

  const { averageGrade, averageRating, objectiveRating } = calculateMetrics(data);

  return (
    <Paper
      elevation={6}
      sx={{
        p: 3,
        borderRadius: 4,
        height: '100%',
        bgcolor: '#fff',
      }}
    >
      <Box display="flex" flexDirection="column" height="100%">
        {/* Top Half */}
        <Box flex={1} display="flex" flexDirection="column" alignItems="center" justifyContent="center">
          <Typography variant="h5" color="primary">
            {averageRating}
          </Typography>
          <Typography variant="h5" color="text.secondary">
            Average rating
          </Typography>
        </Box>

        <Divider />

        {/* Bottom Half */}
        <Box flex={1} display="flex" flexDirection="column" alignItems="center" justifyContent="center">
          <Typography variant="h5" color="primary">
            {objectiveRating}
          </Typography>
          <Typography variant="h5" color="text.secondary">
            Objective rating
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default AverageGradeCard;
